import moment from "moment";

export const dateStringToTimestamp = (value, previousValue, values) => {
    return parseInt(moment(value, "YYYY-MM-DD").format("X"), 10);
};

export const dateStringToDateTime = (value, previousValue, values) => {
    return moment(value, "YYYY-MM-DD").format();
};
export const toInt = (value, previousValue, values) => (parseInt(value, 10));


// WEBPACK FOOTER //
// ./src/lib/FormNormalizers.js